import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/docs/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Link } from 'gatsby';
import { NavigationCard } from '@entur/layout';
import { ButtonGroup, SecondaryButton, SuccessButton } from '@entur/button';
import { ForwardIcon } from '@entur/icons';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const BannerAlertBox = makeShortcode("BannerAlertBox");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "widgets-deprecated"
    }}>{`Widgets (deprecated)`}</h1>
    <BannerAlertBox title="Widgets has been shut down" variant="error" mdxType="BannerAlertBox">
    <p>
        As of August 1st 2024, widgets are no longer supported. We are focusing
        our efforts on developing other services, and we recommend all our users
        to replace widgets with
        <a href="https://entur.no/lag-reiselenke"> Travel link</a>
    </p>
    </BannerAlertBox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      